import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { FooterComponent } from 'apps/toyota/ch/partner-web/src/app/components/footer/footer.component';
import { dealerFeature } from 'libs/ng-common-lib/src/+state/dealer.reducer';
import { wholesaleFeature } from 'libs/ng-common-lib/src/+state/wholesale.reducer';
import { appFeature } from 'libs/partner-web-platform/src/lib/+state/app.reducer';
import { M010C080PhoneRibbonComponent } from 'libs/ui/src/lib/modules/010-buttons-and-links/m010-c080-phone-ribbon/m010-c080-phone-ribbon.component';
import { M050C040MainnavigationPwComponent } from 'libs/ui/src/lib/modules/050-navigation-footer-overlays/m050-c040-mainnavigation-pw/m050-c040-mainnavigation-pw.component';

@Component({
    selector: 'app-root',
    template: `
        <wholesale-m050-c040-mainnavigation-pw />

        @if (phoneRibbonVisible()) {
            @if (navData(); as navi) {
                @if (navi.contact.phone) {
                    <wholesale-m010-c080-phone-ribbon
                        [desktopText]="navi.phoneRibbonDesktopText"
                        [phoneNumber]="navi.contact.phone.number"
                    />
                }
            }
        }

        <router-outlet />

        @defer (hydrate on viewport; prefetch on idle) {
            <app-footer />
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, M010C080PhoneRibbonComponent, M050C040MainnavigationPwComponent, FooterComponent],
})
export default class PartnerComponent {
    protected readonly store = inject(Store);

    lang = this.store.selectSignal(wholesaleFeature.selectLanguage);
    navData = this.store.selectSignal(dealerFeature.selectMainNavigation);
    phoneRibbonVisible = this.store.selectSignal(appFeature.selectPhoneRibbonVisible);
}
